export const createNumberValidationRule = ({
  maxBeforeDecimal = 10,
  maxAfterDecimal = 3,
  allowDecimal = true,
  allowZero = false, // New option to allow '0' as valid input
} = {}) => ({
  validator: (_, value) => {
    const valueNew = String(value);
    if (!value) return Promise.resolve();
    if (!/^\d*\.?\d*$/.test(valueNew)) {
      return Promise.reject(
        'Only numbers are allowed. No special characters or alphabets.',
      );
    }
    if (valueNew.endsWith('.') || valueNew === '.') {
      return Promise.reject('Invalid number format.');
    }
    if ((valueNew.match(/\./g) || []).length > 1) {
      return Promise.reject('Only one decimal point is allowed.');
    }
    if (!allowDecimal && valueNew.includes('.')) {
      return Promise.reject('Decimal values are not allowed.');
    }
    const [beforeDecimal, afterDecimal] = valueNew.split('.');
    if (beforeDecimal.length > maxBeforeDecimal) {
      return Promise.reject(
        `Maximum ${maxBeforeDecimal} digits allowed before the decimal point.`,
      );
    }
    if (allowDecimal && afterDecimal && afterDecimal.length > maxAfterDecimal) {
      return Promise.reject(
        `Maximum ${maxAfterDecimal} digits allowed after the decimal point.`,
      );
    }
    if (parseFloat(valueNew) < 0) {
      return Promise.reject('Negative numbers are not allowed.');
    }
    if (!allowZero && parseFloat(valueNew) === 0) {
      return Promise.reject('Value must be greater than zero.');
    }

    return Promise.resolve();
  },
});
